import currentLocale from 'utils/locale/currentLocale';

const collator = new Intl.Collator(currentLocale, { usage: 'sort' });

const alphabeticSortCompare = collator.compare;

export default alphabeticSortCompare;
